module.exports = __webpack_public_path__ + "img/venu.af299584.jpeg";